/** @jsxImportSource @emotion/react */

import React from "react";

import { ContainerStyle } from "./index.style";

const Container = ({ children }: { children: React.ReactNode }) => {
  return <div css={ContainerStyle.self}>{children}</div>;
};

export default Container;
